export const UrlRegex = /(https?:\/\/\S+)/g;
